import React from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {GroupeLIBPRForm} from "./components/GroupeLIBPRForm";
import {ModeleGroupeLIBPR} from "../../../components/Models";

type LocationState = {data: ModeleGroupeLIBPR | undefined | null}

const GroupeLIBPRPage = () => {
  let {groupeLibprId} = useParams()

  const location = useLocation()
  const state = location.state as LocationState

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {groupeLibprId === undefined ? 'Créer' : 'Modifier'} un Groupe LIBPR
            </h3>
          </div>
        </div>

        <div>
          <GroupeLIBPRForm
            id={groupeLibprId}
            data={state ? state.data : null}
          />
        </div>
      </div>
    </>
  )
}

export {GroupeLIBPRPage}
